module.exports = __webpack_public_path__ + "static/img/auth_icon.5170d7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company/auth_icon.png
// module id = 726
// module chunks = 1